import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Button, TitleH2, TitleH4 } from "components/generic";
import { PublishGrid } from "./styles";
import {
  HOST_PROFILE_EDIT_FIRST_ROUTE,
  HOST_PROFILE_EDIT_ROUTE
} from "utils/constants";

export const DialogPublish: React.FC<{
  requestPublish: Function;
  isVerified: boolean;
  isProfileCompleted: boolean;
}> = ({ requestPublish, isProfileCompleted, isVerified = true }) => {
  const { t, i18n } = useTranslation("hostrooms");
  const navigate = useNavigate();


  if (!isProfileCompleted)
    return (
      <PublishGrid>
        <TitleH2>{t(`publishRequest.title`)}</TitleH2>
        <TitleH4>{t(`publishRequest.notCompletedProfile.text`)}</TitleH4>
        <div>
          <Button normal onClick={() => requestPublish(false)}>
            {t(`publishRequest.buttons.3`)}
          </Button>
          <Button
            main
            onClick={() =>
              navigate(
                `/${i18n.language}${HOST_PROFILE_EDIT_FIRST_ROUTE.slice(5)}`
              )
            }
          >
            {t(`publishRequest.buttons.2`)}
          </Button>
        </div>
      </PublishGrid>
    );

  return (
    <PublishGrid>
      <TitleH2>{t(`publishRequest.title`)}</TitleH2>
      <TitleH4>
        {t(`publishRequest.${isVerified ? "text" : "textWarning"}`, {
          joinArrays: "\n\n"
        })}
      </TitleH4>
      {isVerified ? (
        <div>
          <Button normal onClick={() => requestPublish(false)}>
            {t(`publishRequest.buttons.0`)}
          </Button>
          <Button main onClick={() => requestPublish(true)}>
            {t(`publishRequest.buttons.1`)}
          </Button>
        </div>
      ) : (
        <div>
          <span />
          <Button
            main
            onClick={() =>
              navigate(`/${i18n.language}${HOST_PROFILE_EDIT_ROUTE.slice(5)}`)
            }
          >
            {t(`publishRequest.buttons.2`)}
          </Button>
        </div>
      )}
    </PublishGrid>
  );
};
